import { ComponentType as a } from "../../registries/types/propTypes.js";
const c = (o) => {
  const { theme: t, column_list: n, row_data: e, footer: m, title: r } = o;
  return {
    componentType: a.table_component,
    theme: t,
    columnList: n.column,
    footer: m,
    title: r,
    rowData: e
  };
};
export {
  c as default
};
//# sourceMappingURL=table-component-transformer.js.map
